<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    let LoadingEle = document.getElementById("Loading");
    if (LoadingEle) {
      document.body.removeChild(LoadingEle);
    }
  }
};
</script>

<style lang="scss">
.el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;
  background: rgba(215, 11, 25, 0.50);
  // border: 1px solid #cf4141;
  border-radius: 50%;
}
.el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 10px;
  height: 10px;
  background: rgba(215, 11, 25, 1);
  border-radius: 50%;
}
</style>
